<app-sub-header 
[header]="'Messages'"
[currentStage]="-1"
[totalStage]=""
></app-sub-header> 

<div class="selected-message">

    <div class="message-content">
        <div class="message-content-top">
            <div class="message-content-top-left">

                <button mat-stroked-button class="compose-btn" >
                    <mat-icon>edit</mat-icon>
                Compose
                </button>
            
            
                <button type="button" class="select-mail" mat-button mat-stroked-button [matMenuTriggerFor]="menu">
                    <span class="material-icons">email</span> Inbox<mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-menu #menu="matMenu" >
                    <button mat-menu-item>
                        <mat-icon class="material-icons ">email</mat-icon>
                        <span>Inbox</span>
                    </button>
                    <button mat-menu-item >
                        <mat-icon class="material-icons">send</mat-icon>
                        <span>Sent</span>
                    </button>
                    <button mat-menu-item >
                        <mat-icon class="material-icons">drafts</mat-icon>
                        <span>Drafts</span>
                    </button>
                    <button mat-menu-item >
                        <mat-icon class="material-icons">archive</mat-icon>
                        <span>Archived</span>
                    </button>
                    <button mat-menu-item >
                        <mat-icon class="material-icons">delete</mat-icon>
                        <span>Trash</span>
                    </button>
                </mat-menu>
            </div>
            <div class="message-content-top-right">
                <button type="button" class="select-mail" mat-button mat-stroked-button >
                    <span class="material-icons">archive</span> Archive
                </button>
                <button type="button" class="select-mail" mat-button mat-stroked-button >
                    <span class="material-icons">delete</span> Delete
                </button>
            </div>
        
        </div>

        <div class="message-section">
            <div class="message-greet">
                <mat-label class="font22">Welcome Onboard!</mat-label>
                <div class="massage-label">
                     <mat-chip>
                    inbox
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                    
                  
                </div>
                <!-- <mat-label>Inbox <a href=""><mat-icon>close</mat-icon></a></mat-label></div> -->

        </div>


    
    </div>
</div>
